/**
 * Feedback API Client
 * Handles all feedback-related API requests
 */

import { apiClient } from './client';

export interface Feedback {
  id: string;
  employeeId: string;
  fromUserId: string;
  fromUserName: string;
  fromUserRole?: string;
  rating: number;
  comment: string | null;
  jobId?: string | null;
  jobTitle?: string | null;
  createdAt: string;
}

export interface CreateFeedbackRequest {
  employeeId: string;
  rating: number;
  comment: string;
  jobId?: string;
}

/**
 * Get all feedback for an employee
 */
export async function getEmployeeFeedback(employeeId: string): Promise<Feedback[]> {
  const response = await apiClient.get<Feedback[]>(`/employees/${employeeId}/feedback`);
  return response.data;
}

/**
 * Create new feedback for an employee
 */
export async function createFeedback(
  employeeId: string,
  data: Omit<CreateFeedbackRequest, 'employeeId'>
): Promise<Feedback> {
  const response = await apiClient.post<Feedback>(`/employees/${employeeId}/feedback`, data);
  return response.data;
}

/**
 * Delete feedback
 */
export async function deleteFeedback(feedbackId: string): Promise<void> {
  await apiClient.delete(`/feedback/${feedbackId}`);
}
